import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PositionPayload {
  title: string;
  department: string;
  jobLevel: string;
}

export interface PositionResponse {
  id?: string | number;
  title: string;
  department: string;
  jobLevel: string;
}
export interface PagedPositionsResponse {
  positions: {
    content: PositionResponse[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
  };
  positionNames: string[];
}

export interface PagedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

@Injectable({
  providedIn: 'root',
})
export class PositionService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

getPositions(
  page = 0,
  size = 10,
  filters?: { name?: string; jobLevel?: string; search?: string },
): Observable<PagedPositionsResponse> {
  const companyId = localStorage.getItem('userId') || '';
  let params = new HttpParams()
    .set('page', page.toString())
    .set('size', size.toString());

  if (filters?.name)     params = params.set('name', filters.name);
  if (filters?.jobLevel) params = params.set('jobLevel', filters.jobLevel);
  if (filters?.search)   params = params.set('search', filters.search);

  return this.http.get<PagedPositionsResponse>(
    `${this.baseUrl}api/positions/company/${companyId}`,
    { params },
  );
}
  createPosition(payload: PositionPayload): Observable<PositionResponse> {
    return this.http.post<PositionResponse>(
      `${this.baseUrl}api/positions`,
      payload,
    );
  }

  updatePosition(
    positionId: string | number,
    payload: PositionPayload,
  ): Observable<PositionResponse> {
    return this.http.put<PositionResponse>(
      `${this.baseUrl}api/positions/${positionId}`,
      payload,
    );
  }
  deletePosition(positionId: string | number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}api/positions/${positionId}`);
  }
  getPositionById(id: string | number): Observable<PositionResponse> {
    return this.http.get<PositionResponse>(
      `${this.baseUrl}api/positions/${id}`,
    );
  }
  searchPositions(
  search: string,
  page = 0,
  size = 10,
): Observable<PagedPositionsResponse> {
  const companyId = localStorage.getItem('userId') || '';
  const params = new HttpParams()
    .set('search', search)
    .set('page', page.toString())
    .set('size', size.toString());

  return this.http.get<PagedPositionsResponse>(
    `${this.baseUrl}api/positions/company/${companyId}/search`,
    { params },
  );
}
}
